const NS = 'WoolLabMyMoodboardsBlock';
const CLS = 'woolLabMyMoodboardsBlock';

import Handlebars from 'handlebars';
import { param } from 'jquery';
import utils from '../utils';


export class WoolLabMyMoodboardsBlock {

	constructor(el) {
		this.$el = $(el);

		this.$moodboardContainer = this.$el.find(`.${CLS}-moodboards`);
		this.$searchResultsEmpty = this.$el.find(`.${CLS}-searchResults-empty`);
		this.$myMoodboardsEmpty = this.$el.find(`.${CLS}-myMoodboards-empty`);

		this.moodboardContainer = [];
		this.$searchInp = this.$el.find(`.${CLS}-searchInput`);

		this.$loadingScreen = this.$el.find(`.${CLS}-searchResults-loadingScreen`);
		this.$loadMore = this.$el.find(`.${CLS}-searchResults-loadMore`);
		this.loadingMoodboards = false;
		this.allMoodboardsLoaded = false;

		this.getMoodboardsApi = this.$el.data('getMoodboardsApi');
		this.moodboardBaseUrl = this.$el.data('moodboardBaseUrl');
		this.$moodboards = this.$el.find(`.${CLS}-moodboard`);

		this.pageSize = 30;
		this.pageNumber = 1;

		this.params = {
			// siteId: this.siteId,
			count: this.pageSize,
			offset: 0,
			// pageSize: this.pageSize,
			// keyword: this.$searchInp.val() || ''
		};

		this.handleSearchInput();
		this.handleScrollLoading();
		this.getItems(false);
	}


	// Get items (reload content)
	getItems(loadMoreMoodboards) {

		if (!this.loadingMoodboards && !this.allMoodboardsLoaded) {
			this.loadingMoodboards = true;

			let url = this.getMoodboardsApi;

			if (loadMoreMoodboards) {
				this.setPageNumber(this.pageNumber + 1);
				this.$loadMore.addClass('active');
			} else {
				this.$loadingScreen.addClass('active');
			}

			if (!_.isEmpty(this.params)) {
				url += `?${$.param(this.params)}`;
			}

			this.updateUrl();

			$.ajax({
				type: 'GET',
				url: url,
				success: (data) => {

					this.$myMoodboardsEmpty.hide();

					if (!loadMoreMoodboards) {
						this.$moodboardContainer.empty();
					}

					let moodboardMarkup = (moodboard) => {
						let imgMarkup = '';
						if (moodboard.images.length > 0) {
							for (let i = 0; i < 4; i++) {
								imgMarkup += (`<img class="${CLS}-moodboard-image" src="${moodboard.images[i % moodboard.images.length]}">`)
  							}
						}
						let markup = `
							<div class="${CLS}-moodboard ${moodboard.newContent ? 'newContent' : ''}" data-id="${moodboard.id}" data-name="${moodboard.name}">
								<a>
									<div class="${CLS}-moodboard-image-container">`
										+ imgMarkup +
									`</div>
									<h3 class="${CLS}-moodboard-title">${moodboard.name}</h3>
									<p class="${CLS}-moodboard-count">${moodboard.swatchCount} ${moodboard.swatchCount === 1 ? 'swatch' : 'swatches'}</p>
								</a>
							</div>`;

						return markup;
					};

					if (data.length > 0) {
						data.forEach((item) => {
							this.$moodboardContainer.append(moodboardMarkup(item));
						});
						this.$moodboards = this.$el.find(`.${CLS}-moodboard`);
						this.$moodboards.on('click', (ele) => {
							var moodboard = $(ele.currentTarget);
							window.location.href = `${this.moodboardBaseUrl}?id=${moodboard.data('id')}`
						});

					} else {
						if (loadMoreMoodboards) {
							this.allMoodboardsLoaded = true;
						} else {
							this.$myMoodboardsEmpty.show();
						}
					}

					this.$loadingScreen.removeClass('active');
					this.$loadMore.removeClass('active');
				},
				error: (error) => {
					console.log(error);
				},
				complete: () => {
					this.loadingMoodboards = false;
				},
			});
		}
	}

	// Update url after filters change
	updateUrl() {
		let uri = document.location.pathname;

		Object.keys(this.params).forEach((key, index) => {
			uri = utils.updateQueryStringParameter(uri, key, this.params[key]);
		});

		// update url without reload
		window.history.pushState('', '', uri);
	}

	// Search text input - on type
	handleSearchInput() {
		this.$searchInp.on('keyup', (event) => {
			let input = $(event.currentTarget).val().trim();
			let filter = input.toUpperCase();

			if (this.$moodboards.length > 0) {
				this.$moodboards.map((i, obj) => {
					let txtValue = $(obj).attr('data-name');
					if (txtValue.toUpperCase().indexOf(filter) > -1) {
						obj.style.display = '';
					} else {
						obj.style.display = 'none';
					}
				});
				
				var totalMoodboard = 0;
                var displayNone = 0;
                $(".woolLabMyMoodboardsBlock-moodboard").each(function() {
                    totalMoodboard++;
                });
                $(".woolLabMyMoodboardsBlock-moodboard").each(function() {
                    if($( this ).css("display") == "none"){
                        displayNone ++;
                    }
                });
                if (displayNone == totalMoodboard)  {
					this.$searchResultsEmpty.show();
				}
				else{
					this.$searchResultsEmpty.hide();
				}
				
			}
		});
	}

	handleScrollLoading() {

		let offsetFromBottom = 200;

		const This = this;

		$(document).on('touchmove', onScroll); // for mobile
		function onScroll() {
			if ($(window).scrollTop() + offsetFromBottom > $(document).height() - $(window).height()-100) {
				This.getItems(true);
			}
		}

		$(window).scroll(function() {
			let position = $(window).scrollTop() + offsetFromBottom;
			let bottom = $(document).height() - $(window).height();

			if ( position >= bottom ) {
			   This.getItems(true);
			}
		 });
	}

	setPageNumber(newPageNumber) {
		this.pageNumber = newPageNumber;
		this.params.offset = (this.pageNumber - 1) * this.pageSize;
	}
}
